const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

const asArray = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean)
  return value ? [value] : []
}

const groupLabel = (group) => {
  if (!group || typeof group !== 'object') return null
  return group.label || group.name || group.title || null
}

export const resolveAssociatedUserGroupLabels = (...sources) => {
  const candidates = sources.reduce((all, source) => all.concat(asArray(source)), [])
  const labelsByUuid = new Map()

  candidates.forEach((candidate) => {
    if (!candidate || typeof candidate !== 'object') return
    const label = groupLabel(candidate)
    const uuid = candidate.uuid || candidate.id
    if (label && uuid) labelsByUuid.set(String(uuid), label)
  })

  const labels = new Set()
  candidates.forEach((candidate) => {
    if (typeof candidate === 'string') {
      const mappedLabel = labelsByUuid.get(candidate)
      if (mappedLabel) {
        labels.add(mappedLabel)
      } else if (!UUID_PATTERN.test(candidate)) {
        labels.add(candidate)
      }
      return
    }

    const label = groupLabel(candidate)
    if (label) labels.add(label)
  })

  return [...labels]
}
